import DataTable from '@/containers/data_table_ml/DataTable';
import ButtonML from '@/components/button_ml/ButtonML';
import { Tag } from 'antd';
const TablePage = (props) => {
  const { loadingstatus, tableData, showModal, pagination } = props || {};
  const columns = [
    {
      title: '执行 ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      align: 'center',
    },
    {
      title: '决策图名称',
      dataIndex: 'diagramName',
      key: 'diagramName',
      width: 160,
    },
    {
      title: '决策图编号',
      dataIndex: 'strategyCode',
      key: 'strategyCode',
      width: 90,
    },
    {
      title: '决策图版本',
      dataIndex: 'version',
      key: 'version',
      width: 80,
    },
    {
      title: '用户编号',
      dataIndex: 'userNo',
      key: 'userNo',
      width: 120,
    },
    {
      title: '输入',
      dataIndex: 'inputValues',
      key: 'inputValues',
      width: 60,
      align: 'center',
      render: (record) => {
        return (
          <ButtonML
            type="link"
            size="large"
            value="输入"
            fontsize="16px"
            onClick={() => {
              showModal(record, 'in');
            }}
          />
        );
      },
    },
    {
      title: '输出',
      dataIndex: 'outputValues',
      key: 'outputValues',
      width: 60,
      align: 'center',
      render: (record) => {
        return (
          <ButtonML
            type="link"
            size="large"
            value="输出"
            fontsize="16px"
            onClick={() => {
              showModal(record, 'out');
            }}
          />
        );
      },
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      width: 60,
      align: 'center',
      render: (record) => {
        let color = record === 'TEST' ? 'red' : 'green';
        return (
          <Tag color={color} key={record}>
            {record}
          </Tag>
        );
      },
    },
    {
      title: '状态',
      dataIndex: 'state',
      key: 'state',
      width: 60,
      align: 'center',
      render: (record) => {
        let color =
          record === 'RUNNING'
            ? 'blue'
            : record === 'FINISHED'
            ? 'green'
            : record === 'EXCEPTION'
            ? 'red'
            : 'orange';
        return (
          <Tag color={color} key={record}>
            {record}
          </Tag>
        );
      },
    },
    {
      title: '开始时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 100,
      align: 'center',
    },
    {
      title: '结束时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 100,
      align: 'center',
    },
  ];
  return (
    <DataTable
      className="demo-test"
      // style={{ minWidth: '1547px' }}
      columns={columns}
      rowSelection={false}
      scroll={{
        x: 1547,
        y: 'calc(100vh - 350px)',
      }}
      loading={loadingstatus}
      dataSource={tableData}
      pagination={pagination}
      changePage={(a) => {
        props.pageNumChange(a);
      }}
      changePageSize={(a) => {
        props.pageSizeChange(a);
      }}
    />
  );
};
export default TablePage;
